<template>
    <v-switch
            flat
            dense
            hide-details
            :loading="loading"
            :disabled="loading"
            :label="label"
            color="info"
            :input-value="status"
            @change="onService"
            class="ml-auto"
            inset
    ></v-switch>
</template>

<script>
    export default {
        props: {
            id: Number,
            status: Number,
        },
        data() {
            return {
                loading: false,
            }
        },
        computed: {
            label() {
                return this.status ? 'Working' : 'Service';
            }
        },
        methods: {
            onService(value) {
                this.loading = true;
                this.$store.dispatch('gpus/service', {id: this.id, status: value}).then(() => {

                }).finally(() => {
                    this.loading = false;
                });
            }
        }
    }
</script>
